import React from "react";
import { useTranslation } from "react-i18next";
import { DetailTypeMoocCourseConstructionPlan } from "../../../../../../types/course-plan-managment/mooc-course-construction-plan";
import CustomCard from "../../../../../../components/custom-card/CustomCard";
import { Badge, Typography } from "antd";
import { ApprovalStatusEnum, StatusEum } from "../../../../mooc-course-construction-plan/list-course-plan/constants/data";

interface DetailInfoProps {
  detailData: any;
  ltsIndustry: any;
  ltsIndustryGroup: any;
  ltsCollabUniversity: any;
  hostUniversity: any;
}

const DetailInfo: React.FC<DetailInfoProps> = ({
  detailData,
  ltsIndustry,
  ltsIndustryGroup,
  ltsCollabUniversity,
  hostUniversity,
}) => {
  const { t } = useTranslation();
  const handleString = (e: any[]) => {
    let title: string = "";
    if (e.length > 0) {
      e.forEach((m) => {
        title = title + m.name + ", ";
      });
      title = title.slice(0, -2);
    }

    return title;
  };

  const handleReturnCourseType = (courseType: number) => {
    switch (courseType) {
      case 1:
        return t("Tự triển khai", "Tự triển khai");
      case 2:
        return t("Hợp tác xây dựng", "Hợp tác xây dựng");
      case 3:
        return t("Dùng chung", "Dùng chung");
      default:
        return "";
    }
  };

  const handleReturnStatus = (record: any) => {
    switch (record.construction_plan_status) {
      case StatusEum.SAVE_DRAFT:
        return t("Lưu bản nháp", "Lưu bản nháp");
      case StatusEum.WAIT_APPROVE:
        if (record.approval_status && record.approval_level_name) {
          switch (record.approval_status) {
            case ApprovalStatusEnum.WAIT_APPROVE:
              return `${t("Chờ duyệt", "Chờ duyệt")} (${record.approval_level_name})`;
            case ApprovalStatusEnum.APPROVED:
              return `${record.approval_level_name} ${t("Đã duyệt", "Đã duyệt")}`;
            case ApprovalStatusEnum.REFUSE:
              return `${record.approval_level_name} ${t("Từ chối", "Từ chối")}`;
            default:
              return t("Chờ duyệt", "Chờ duyệt");
          }
        }
        return t("Chờ duyệt", "Chờ duyệt");
      case StatusEum.APPROVED:
        return t("Hội đồng thẩm định đã duyệt", "Hội đồng thẩm định đã duyệt");
      case StatusEum.REFUSE:
        return t("Quản trị khóa học từ chối", "Quản trị khóa học từ chối");

      default:
        return "";
    }
  };

  return (
    <div>
      <CustomCard
        title={
          <div className="card-heading--info">
            <Typography.Title level={5}>
              {t("Thông tin kế hoạch khóa học", "Thông tin kế hoạch khóa học")}
            </Typography.Title>
            <Typography.Text className="sub-title">
              {t("Thông tin chung về kế hoạch xây dựng khóa học", "Thông tin chung về kế hoạch xây dựng khóa học")}
            </Typography.Text>
          </div>
        }
        className="card-info--wrapper"
      >
        <div className="list-wrapper">
          <div className="list-item">
            <Typography.Title level={5} className="list-item--title">
              {t("Tên kế hoạch", "Tên kế hoạch")}
            </Typography.Title>

            <div className="list-item--description">
              <Typography.Text className="content">
                {detailData.registration_name}
              </Typography.Text>
            </div>
          </div>
          <div className="list-item">
            <Typography.Title level={5} className="list-item--title">
              {t("Mã kế hoạch", "Mã kế hoạch")}
            </Typography.Title>

            <div className="list-item--description">
              <Typography.Text className="content">
                {detailData.registration_code}
              </Typography.Text>
            </div>
          </div>
          <div className="list-item">
            <Typography.Title level={5} className="list-item--title">
              {t("Trạng thái", "Trạng thái")}
            </Typography.Title>

            <div className="list-item--description">
              <Typography.Text className="content">
                <Badge
                  key={detailData.construction_plan_status}
                  color={
                    parseInt(detailData.construction_plan_status) === 1
                      ? "#D9D9D9"
                      : parseInt(detailData.construction_plan_status) === 2
                        ? "#FAAD14"
                        : parseInt(detailData.construction_plan_status) === 3
                          ? "#52C41A"
                          : parseInt(detailData.construction_plan_status) === 4
                            ? "#FF4D4F"
                            : "white"
                  }
                  style={{ marginRight: 5 }}
                />
                {handleReturnStatus(
                  detailData
                )}
              </Typography.Text>
            </div>
          </div>
          {ltsIndustry !== undefined &&
            ltsIndustry.length > 0 ? (
            <div className="list-item">
              <Typography.Title level={5} className="list-item--title">
                {t("Khoa", "Khoa")}
              </Typography.Title>

              <div className="list-item--description">
                <Typography.Text className="content">
                  {handleString(ltsIndustry)}
                </Typography.Text>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          {ltsIndustryGroup !== undefined && ltsIndustryGroup.length > 0 ? (
            <div className="list-item">
              <Typography.Title level={5} className="list-item--title">
                {t("Chuyên ngành", "Chuyên ngành")}
              </Typography.Title>

              <div className="list-item--description">
                <Typography.Text className="content">
                  {handleString(ltsIndustryGroup)}
                </Typography.Text>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          {hostUniversity !== undefined ? (
            <div className="list-item">
              <Typography.Title level={5} className="list-item--title">
                {t("Trường chủ trì", "Trường chủ trì")}
              </Typography.Title>

              <div className="list-item--description">
                <Typography.Text className="content">
                  {hostUniversity.name}
                </Typography.Text>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          {ltsCollabUniversity !== undefined && ltsCollabUniversity.length > 0 ? (
            <div className="list-item">
              <Typography.Title level={5} className="list-item--title">
                {t("Trường hợp tác", "Trường hợp tác")}
              </Typography.Title>

              <div className="list-item--description">
                <Typography.Text className="content">
                  {handleString(ltsCollabUniversity)}
                </Typography.Text>
              </div>
            </div>
          ) : (
            <div></div>
          )}
          <div className="list-item">
            <Typography.Title level={5} className="list-item--title">
              {t("Loại khóa học", "Loại khóa học")}
            </Typography.Title>

            <div className="list-item--description">
              <div className="table-course-type">
                {parseInt(detailData.course_type) === 2 ? (
                  <div className="table-course-type-2">
                    {handleReturnCourseType(parseInt(detailData.course_type))}
                  </div>
                ) : parseInt(detailData.course_type) === 1 ? (
                  <div className="table-course-type-1">
                    {handleReturnCourseType(parseInt(detailData.course_type))}
                  </div>
                ) : parseInt(detailData.course_type) === 3 ? (
                  <div className="table-course-type-3">
                    {handleReturnCourseType(parseInt(detailData.course_type))}
                  </div>
                ) :
                  (
                    ""
                  )}
              </div>
            </div>
          </div>
        </div>
      </CustomCard>
    </div>
  );
};

export default DetailInfo;
